import { Container } from '@/components/Container'


export function ContactHero() {
  return (
    <Container className="pt-20 pb-4 text-center lg:pt-4">
      <h1 className="mx-auto max-w-4xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-7xl">
      Get in touch
      </h1>
      <p className="mx-auto mt-6 max-w-2xl text-lg tracking-tight text-slate-700">
      We’d love to hear from you! Send us a message using the form. We’d love to hear from you! 
      </p>
    </Container>
  )
}
